/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { IInspectorControl_Expand, TInspectorControlProps } from "../InspectorControlTypes";
import { FieldExpandButton, FieldGroup } from "@adapptio/lib-editor-ui";
import { useBlueprintModel } from "../../../ui/hooks/useBlueprintModel";
import { InvalidModelNode } from "../../../ui/components/Inspector/InvalidModelNode";
import { IConstObject_EditorMetaData } from "../../mappers/constObjectMapper";

export interface IInspectorControlExpandProps extends TInspectorControlProps<IInspectorControl_Expand> {}

export const InspectorControlExpand: React.FC<IInspectorControlExpandProps> = ({ model: _model }) => {
	const { model } = useBlueprintModel(_model, "constObject");

	const toggleShowExpanded = useCallback(() => {
		if (!model) {
			return;
		}

		const prevMeta = model.schema.getEditorMetaData<IConstObject_EditorMetaData>(model);
		model.schema.setEditorMetaData<IConstObject_EditorMetaData>(model, {
			showExpanded: !prevMeta.showExpanded
		});
	}, [ model ]);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	const meta = model.schema.getEditorMetaData<IConstObject_EditorMetaData>(model);

	return (
		<FieldGroup>
			<FieldExpandButton selected={meta.showExpanded} onClick={toggleShowExpanded} />
		</FieldGroup>
	);
};
